// Don't know my size
// let notKonwSizeName = "Don't know my size";
// // 第一次点击标识
// let firstClickFlag = true;
// var sizeGuidePage = document.querySelector("#size-chart-template--22349479149876__main-variant_picker")
// if (sizeGuidePage) {
//     let fieldset =document.querySelectorAll(
//         "fieldset"
//       )[1];
//      let sizeOpionEls = fieldset.querySelectorAll(
//         ".variant-picker__option-values input"
//       );
//   sizeOpionEls.forEach(function (sizeOptionEl) {
//     sizeOptionEl.addEventListener("click", function () {
//       console.log('addEventListener')
//       if (firstClickFlag) {
//         sizeGuidePage.setAttribute("open", "");
//         firstClickFlag = false;
//       }
//     });
//   });
// }

var Popup = {
  /*
   * alert 弹窗 text 必传
   */
  /*
   * 确定弹窗
   */
  sureAlert: function () {
    var model = document.getElementById('popupMark');
    model.style.display = 'none';
  },
  confirm: function (text, fn) {
    var model = document.getElementById('popupConfirm');
    if (model) {
      var content = document.getElementById('confirmText');
      content.innerHtml = text;
      model.style.display = 'block';
      return;
    }
    var creatediv = document.createElement('div'); // 创建div
    creatediv.className = 'popup_mark'; // 添加class
    creatediv.setAttribute('id', 'popupConfirm'); // 添加ID
    var contentHtml =
      '<div class="popup_box">' +
      '<h2>RingConn Store Upgrade Notice</h2>' +
      '<p id="confirmText">' +
      text +
      '</p>' +
      '<div class="confirmBtn"><a id="yesConfirm" href="javascript:void(0)">Send Activation Email</a></div>' +
      '<div class="closePopup" id="closeConfirm"></div>' +
      '</div>';
    creatediv.innerHTML = contentHtml;
    document.body.appendChild(creatediv);
    document.getElementById('closeConfirm').addEventListener('click', function () {
      Popup.closeConfirm();
    });
    // document
    //   .getElementById("cancelConfirm")
    //   .addEventListener("click", function () {
    //     Popup.closeConfirm();
    //   });
    document.getElementById('yesConfirm').addEventListener('click', function () {
      Popup.sureConfirm(fn);
    });
  },
  closeConfirm: function () {
    var model = document.getElementById('popupConfirm');
    model.style.display = 'none';
  },
  sureConfirm: function (fn) {
    var model = document.getElementById('popupConfirm');
    model.style.display = 'none';
    if (typeof fn == 'function') {
      fn();
    }
  },
};

function userInvite(id) {
  fetch(`${window.ShopifyInfo.baseUrl}/admin/order/UserInvite`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      customerId: id,
    }),
  })
    .then((res) => {
      return res.json();
    })
    .then((data) => {});
}

// 获取登录表单
var customerEmail = document.getElementById('input-template--21720014946612__main--customeremail');

var customerPassword = document.getElementById('input-template--21720014946612__main--customerpassword');

var customerPassword = document.getElementById('input-template--21720014946612__main--customerpassword');

let dialogFlag = false;

customerPassword?.addEventListener('focus', function () {
  if (customerEmail.value.length > 0) {
    fetch(`${window.ShopifyInfo.baseUrl}/admin/order/UserState`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: customerEmail.value,
      }),
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.payload.state == 10) {
          let msg = `
            We've upgraded for an enhanced experience! You are invited to activate your account.<br>
Click the button below to have an activation link sent from <strong>store@ringconn.com </strong> - just check your inbox or spam folder to proceed.`;
          Popup.confirm(msg, function () {
            userInvite(data.payload.customerId);
          });
        }
      });
  }
});
